import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import cartInfo from "./AddToCart.module.css";
import { Button, Modal } from "react-bootstrap";
import BookInfo from "../BookModule.module.css";
import { CurrencyRupee } from "@mui/icons-material";
import PreOrderNote from "../PreOrderNote";
import CardTemplate from "../CardTemplate";
import { AxiosInstance } from "../../../../../axios";
import toast from "react-hot-toast";
import moment from "moment";
import Swal from "sweetalert2";
import { GSTPRICE, ImageUrlPrefix, BookPaymentSKey } from "../../../../../labels";
import { Dialog, DialogContent } from "@mui/material";
import PdfImage from "../pdf.png";
import { CartContext } from "../../../../../context/CartItems";
import { WishListContext } from "../../../../../context/WishListItems";
import PaginationTop10 from "../../../../../pages/dashboard/PaginationTop10";

export default function AddToCart({ wishlist, order }) {
  const moment = require("moment-timezone");
  // Swastic
  const { cartNotify, cartdeleteNotify } = useContext(CartContext);
  const { WishNotify } = useContext(WishListContext);
  const [count, setCount] = useState(1); // Initial value set to 1
  const [totalFinalPrice, setTotalFinalPrice] = useState(0);
  const [totalOfferValue, setTotalOfferValue] = useState(0);
  // Quantity check validation corrections
  const [validationErrors, setValidationErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState(""); // For success messages
  const [courierCharges, setCourierCharge] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [updateListData, setUpdateListData] = useState([]);

  const [errorMessage, setErrorMessage] = useState([]);
  const optional_paper_ref = useRef(null);
  const deliveryRef = useRef(null);
  const txtadVerifyHere = useRef(null);
  const [error, setError] = useState({});
  const [bookListData, setBookListData] = useState([]);
  const [preorderListData, setPreorderListDate] = useState([]);
  const [initialfields, setInitialfields] = useState({
    deliveryMode: 1,
    quantityCount: 1,
    name: "",
    phoneNumber: "",
    address: "",
    Pincode: "",
    EditID: "",
    couponCode: "",
    rewardPoints: "",
    Verify: false,
  });

  const [delivery, setDelivery] = useState([]);
  // nEW POPUP
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [couponApplied, setCouponApplied] = useState({
    status: false,
    amount: 0,
    coupon_code: "",
  });
  const [rewardsnApplied, setRewardsApplied] = useState({
    status: false,
    amount: 0,
    rewardPoints: "",
  });

  const [listErrors, setListErrors] = useState({});
  const [rewardAmount, setRewardAmount] = useState(0);

  const [message, setMessage] = useState("");
  const [rewardMessage, setRewardMessage] = useState("");

  const [branchdelivery, setBranchdelivery] = useState([]);

  const [open, setOpen] = useState(false);
  const [isEditopen, setisEditopen] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [isstockLoading, setIsstockLoading] = useState(false);
  const [flagReload, setFlagReload] = useState(false);

  const [allEBook, setAllEBook] = useState(false);
  const navigate = useNavigate();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("UserId Not available");
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const handleIncreaseModel = (id) => {
  //   if (count < 10) {
  //     let updatedBookListData = [];
  //     setBookListData((prev) => {
  //       updatedBookListData = prev.map((item) => {
  //         if (
  //           item.id === id &&
  //           item.count < item.stock_count &&
  //           item.is_set === 0
  //         ) {
  //           return {
  //             ...item,
  //             count: item.count + 1,
  //             finalPriceChanged: parseFloat(
  //               (item.price * (item.count + 1)).toFixed(2)
  //             ),
  //           };
  //         } else if (item.id === id && item.is_set === 1) {
  //           return {
  //             ...item,
  //             count: item.count + 1,
  //             finalPriceChanged: parseFloat(
  //               (item.price * (item.count + 1)).toFixed(2)
  //             ),
  //           };
  //         } else {
  //           return item;
  //         }
  //       });

  //       return updatedBookListData; // Return the updated list
  //     });

  //     setError((prevState) => ({
  //       ...prevState,
  //     }));
  //   } else {
  //     setError((prevState) => ({
  //       ...prevState,
  //       addMaxBook: "You can select a maximum of 10 books.",
  //     }));
  //   }

  //   const getcquanity =
  //     bookListData?.find((er) => er.id === id)?.count + 1 || 1;
  //   const changeQuantity = {
  //     id: id,
  //     user_id: userid,
  //     quantity: getcquanity,
  //     is_removed: 0,
  //     created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
  //     created_by: userid,
  //   };
  //   setIsstockLoading(true);
  //   AxiosInstance.post(`api/book/cart/update`, changeQuantity)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         setIsstockLoading(false);
  //         toast.success(res.data.message);
  //         // navigate("/studyMaterials/Books/list");
  //       } else {
  //         setIsstockLoading(false);
  //         toast.error(res.data.message);
  //       }
  //     })
  //     .catch((error) => {
  //       setIsstockLoading(false);
  //       console.error(error);
  //     });
  // };

  // const handleDecreaseModel = (id) => {
  //   setBookListData((prev) =>
  //     prev.map((item) => {
  //       if (item.id === id) {
  //         const newCount = item.count > 1 ? item.count - 1 : 1; // Ensure count doesn't go below 1
  //         return {
  //           ...item,
  //           count: newCount,
  //           finalPriceChanged: parseFloat((item.price * newCount).toFixed(2)), // Use original price for recalculation
  //         };
  //       } else {
  //         return item;
  //       }
  //     })
  //   );
  //   const getcquanityDe =
  //     bookListData?.find((er) => er.id === id)?.count - 1 || 1;
  //   const changeQuantity = {
  //     id: id,
  //     user_id: userid,
  //     quantity: getcquanityDe,
  //     is_removed: 0,
  //     created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
  //     created_by: userid,
  //   };
  //   setIsstockLoading(true);
  //   AxiosInstance.post(`api/book/cart/update`, changeQuantity)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         setIsstockLoading(false);
  //         toast.success(res.data.message);
  //         // navigate("/studyMaterials/Books/list");
  //       } else {
  //         setIsstockLoading(false);
  //         toast.error(res.data.message);
  //       }
  //     })
  //     .catch((error) => {
  //       setIsstockLoading(false);
  //       console.error(error);
  //     });
  // };

  const handleIncreaseModel = (id) => {
    setBookListData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          const newCount = (item.pendingQuantity ?? item.count) + 1;
          const price = parseFloat(item.price) || 0;
          const offer = parseFloat(item.offer_percentage) || 0;
          const offerValue = (price * offer * newCount) / 100;
          const finalPriceChanged = price * newCount - offerValue;

          return {
            ...item,
            count: newCount,
            pendingQuantity: newCount,
            finalPriceChanged,
            isApplied: false,
          };
        }
        return item;
      })
    );
  };

  const handleDecreaseModel = (id) => {
    setBookListData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          const newCount = (item.pendingQuantity ?? item.count) - 1;
          const price = parseFloat(item.price) || 0;
          const offer = parseFloat(item.offer_percentage) || 0;
          const offerValue = (price * offer * newCount) / 100;
          const finalPriceChanged = price * newCount - offerValue;

          return {
            ...item,
            count: newCount,
            pendingQuantity: newCount,
            finalPriceChanged,
            isApplied: false,
          };
        }
        return item;
      })
    );
  };

  const allApplied =
    bookListData.length > 0 && bookListData.every((b) => b.isApplied);

  const handleApplyQuantity = (id) => {
    const book = bookListData.find((b) => b.id === id);
    if (!book) return;

    // Determine quantity to update (use pendingQuantity if available)
    const qtyToUpdate = book.pendingQuantity ?? book.count;

    // Check stock (optional)
    // if (book.is_set === 0 && qtyToUpdate > book.stock_count) {
    //   toast.error(`Only ${book.stock_count} books are available in stock.`);
    //   return;
    // }

    // Update local state immediately
    setBookListData((prev) =>
      prev.map((b) =>
        b.id === id
          ? {
            ...b,
            count: qtyToUpdate,
            finalPriceChanged: parseFloat((b.price * qtyToUpdate).toFixed(2)),
            pendingQuantity: undefined,
            isApplied: false,
          }
          : b
      )
    );

    // Create payload
    const changeQuantity = {
      id,
      user_id: userid,
      quantity: qtyToUpdate,
      is_removed: 0,
      created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
      created_by: userid,
    };

    setIsstockLoading(true);
    AxiosInstance.post(`api/book/cart/update`, changeQuantity)
      .then((res) => {
        setIsstockLoading(false);
        if (res.data.status) {
          toast.success(res.data.message);
          setBookListData((prev) =>
            prev.map((b) => (b.id === id ? { ...b, isApplied: true } : b))
          );
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        setIsstockLoading(false);
        console.error(error);
      });
  };

  // const handleApplyQuantity = (id) => {
  //   let isStockValid = true;
  //   let qtyToUpdate = 1;

  //   setBookListData((prev) =>
  //     prev.map((b) => {
  //       if (b.id === id) {
  //         const qty = b.pendingQuantity ?? b.count;

  //         // Check stock availability
  //         // if (b.is_set === 0 && qty > b.stock_count) {
  //         //   toast.error(`Only ${b.stock_count} books are available in stock.`);
  //         //   isStockValid = false;
  //         //   return b;
  //         // }

  //         qtyToUpdate = qty;

  //         return {
  //           ...b,
  //           count: qty,
  //           finalPriceChanged: parseFloat((b.price * qty).toFixed(2)),
  //           pendingQuantity: undefined,
  //         };
  //       }
  //       return b;
  //     })
  //   );

  //   if (!isStockValid) return;

  //   const changeQuantity = {
  //     id,
  //     user_id: userid,
  //     quantity: qtyToUpdate,
  //     is_removed: 0,
  //     created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
  //     created_by: userid,
  //   };

  //   setIsstockLoading(true);
  //   AxiosInstance.post(`api/book/cart/update`, changeQuantity)
  //     .then((res) => {
  //       setIsstockLoading(false);
  //       if (res.data.status) {
  //         toast.success(res.data.message);

  //         // ✅ Mark only this book as applied
  //         setBookListData((prev) =>
  //           prev.map((b) => (b.id === id ? { ...b, isApplied: true } : b))
  //         );
  //       } else {
  //         toast.error(res.data.message);
  //       }

  //       // if (res.status === 200) toast.success(res.data.message);
  //       // else toast.error(res.data.message);
  //     })
  //     .catch((error) => {
  //       setIsstockLoading(false);
  //       console.error(error);
  //     });
  // };

  useEffect(() => {
    handleAddresslist();
  }, []);
  useEffect(() => {
    loadListData();
  }, []);

  const loadListData = async () => {
    setIsLoading(true);
    try {
      const res = await AxiosInstance.post(`/api/book/courier/list`);
      if (res.status === 200 && Array.isArray(res.data.data)) {
        setUpdateListData(res.data.data);
      } else {
        setUpdateListData([]);
      }
    } catch (error) {
      console.error("Error loading data:", error);
      setUpdateListData([]);
    }
    setIsLoading(false);
  };
  const navigateToPreviousScreen = () => {
    navigate("studyMaterials/Books/ViewAllBook");
  };

  const handleRemove = (id) => {
    const updateCoupon = {
      id: id,
      user_id: userid,
      quantity: count,
      is_removed: 1,
      created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
      created_by: userid,
    };
    setIsstockLoading(true);
    AxiosInstance.post(`api/book/cart/update`, updateCoupon)
      .then((res) => {
        setValidationErrors({});
        if (res.data.status) {
          setIsstockLoading(false);
          toast.success(res.data.message);
          setFlagReload(!flagReload);
          cartdeleteNotify(id);
        } else {
          setIsstockLoading(false);
          toast.error(res.data.message);

          setFlagReload(true);
        }
      })
      .catch((error) => {
        setIsstockLoading(false);
        console.error(error);
      });
  };

  useEffect(() => {
    if (bookListData.length > 0) {
      const isAllEBooks = bookListData.every((book) => book.is_ebook === 1);
      setAllEBook(isAllEBooks);
    }
  }, [bookListData]);

  useEffect(() => {
    handleAddresslist();
  }, [open, isEditopen]);

  useEffect(() => {
    AxiosInstance.post("api/branch/list")
      .then((res) => {
        setBranchdelivery(
          res.data.data.map((item) => ({
            id: item.id,
            name: item.name,
            phoneNumber: item.mobile_no,
            address: item.address,
            Pincode: item.zipcode,
          }))
        );
      })
      .catch((error) => {
        console.error("Error fetching branch list:", error);
      });
  }, []);

  useEffect(() => {
    cartList();
  }, [flagReload]);

  function cartList() {
    AxiosInstance.post("api/book/cart/list", { user_id: userid })
      .then((res) => {
        if (res.data.status) {
          setBookListData(
            res.data.data.map((item) => ({
              ...item,
              isApplied: true,
              count: item.quantity,
              finalPriceChanged: item.price * item.quantity,
            }))
          );
          setPreorderListDate(res.data.pre_order_items);
        } else {
          setBookListData([]);
          setPreorderListDate([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const handleChange = (event) => {
    const { name, value, checked } = event.target;
    console.log(value, "valuevalue");

    if (name === "rewardPoints" && !/^\d*$/.test(value)) {
      return;
    }
    const numericValue = value.replace(/[^0-9]/g, "");
    if (name === "phoneNumber") {
      if (value.length === 10 || value.length === 0) {
        setInitialfields((prevList) => ({
          ...prevList,
          [name]: value,
          [name]: numericValue,
        }));
        setError({
          ...error,
          ["phoneNumber"]: "",
        });
      } else {
        setInitialfields((prevList) => ({
          ...prevList,
          [name]: value,
          [name]: numericValue,
        }));
        setError({
          ...error,
          ["phoneNumber"]: "Please enter valid 10 digit number",
        });
        return;
      }
    } else if (name === "Pincode") {
      if (numericValue.length === 6 || numericValue.length === 0) {
        setInitialfields((prevList) => ({
          ...prevList,
          [name]: numericValue,
        }));
        setError((prevError) => ({
          ...prevError,
          Pincode: "",
        }));
      } else {
        setInitialfields((prevList) => ({
          ...prevList,
          [name]: numericValue,
        }));
        setError((prevError) => ({
          ...prevError,
          Pincode: "Please enter a valid 6 digit pincode number",
        }));
        return; // Stop further execution for invalid Pincode
      }
    } else if (name == "couponCode") {
      if (value == "") {
        setCouponApplied({
          status: false,
          amount: 0,
          coupon_code: "",
        });
        setMessage("");
      } else {
        setCouponApplied((prevState) => ({
          ...prevState,
          coupon_code: value,
        }));
        setMessage("");
        setListErrors({
          ...listErrors,
          ["coupon_code"]: "",
        });
      }
    } else if (name == "rewardPoints") {
      if (value == "") {
        setRewardAmount(0);

        setInitialfields((prevState) => ({
          ...prevState,
          status: false,
          amount: 0,
          rewardPoints: "",
        }));
        setRewardsApplied({ status: false, amount: 0, rewardPoints: "" });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          rewardPoints: value,
        }));
        setListErrors({
          ...listErrors,
          ["rewardPoints"]: "",
        });
        setRewardAmount(0);
        setRewardsApplied({ status: false, amount: 0, rewardPoints: "" });
      }
    } else if (name === "deliveryMode") {
      setInitialfields({
        ...initialfields,
        deliveryMode: initialfields.deliveryMode === 1 ? 0 : 1,
      });
      setSelectedId("");
    } else if (name == "Verify") {
      setInitialfields((prevList) => ({
        ...prevList,
        [name]: checked,
      }));
      setError((prevError) => ({
        ...prevError,
        Verify: "",
      }));
    } else {
      setInitialfields((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
      if (name === "coupon_code") {
        setListErrors((prevErrors) => ({
          ...prevErrors,
          ["coupon_code"]: "",
        }));
      }
      setError({
        ...error,
        [name]: "",
      });
    }
  };

  const handleAddresslist = () => {
    AxiosInstance.post("/api/book/cart/address/list", {
      user_id: userid,
    })
      .then((res) => {
        if (res.data.status) {
          setDelivery(res.data.data);
        } else {
          setDelivery([]);
        }
      })
      .catch((error) => {
        return error;
      });
  };

  //   Swastic Coupon
  // Handle form submission

  const handleApplyCoupon = (e, dAmount, id) => {
    let code = couponApplied.coupon_code;
    let BatchAmount = totalFinalPrice.toFixed(2);

    AxiosInstance.post(`api/all/getCoupon`, {
      user_id: userid,
      coupon_code: code,
    })
      .then((res) => {
        const message = res.data.message;
        setMessage(message);
        setListErrors({
          ...listErrors,
          ["coupon_code"]: "",
        });

        if (res.data[0].status === true) {
          if (res.data[0].data.dis_amt + totalOfferValue >= BatchAmount) {
            setListErrors({
              ...listErrors,
              ["coupon_code"]:
                "The coupon code exceeds the amount payable  and cannot be applied",
            });

            setCouponApplied((prevState) => ({
              ...prevState,
              coupon_code: "",
            }));
          } else {
            setListErrors({});
            setCouponApplied({
              status: true,
              amount: res.data[0].data.dis_amt,
              coupon_code: res.data[0].data.id,
            });
            setMessage("Coupon code applied successfully");
          }
        } else {
          toast.error(res.data.message);
          // Swal.fire({
          //   title: "Warning",
          //   text: "coupon code is not avaliable ",
          //   icon: "Warning",
          //   confirmButtonText: "Ok",
          // });
        }
      })
      .catch((error) => {
        return error;
      });
  };

  useEffect(() => {
    if (parseInt(rewardAmount) + totalOfferValue > totalFinalPrice) {
      setListErrors((prev) => ({
        ...prev,
        rewardPoints:
          "The reward points exceed the amount payable and cannot be applied",
      }));
      setListErrors({
        ...listErrors,
        ["rewardPoints"]:
          "The reward points exceeds the amount payable and cannot be applied",
      });
      setRewardsApplied((prevState) => ({
        ...prevState,
        status: false,
        rewardPoints: "",
      }));
    }
  }, [rewardAmount, totalFinalPrice, totalOfferValue]);

  const handleApplyReward = (dAmount) => {
    let code = initialfields.rewardPoints;
    setRewardMessage("");

    if (initialfields.rewardPoints > 0) {
      AxiosInstance.post(`api/book/user_rewards`, {
        user_id: userid,
        amount: parseInt(code) || "",
      })
        .then((res) => {
          if (res.data.status) {
            if (
              parseInt(initialfields.rewardPoints) +
              parseInt(totalOfferValue) +
              (couponApplied.status &&
                message === "Coupon code applied successfully"
                ? parseInt(couponApplied.amount)
                : 0) >=
              totalFinalPrice
            ) {
              setListErrors({
                ...listErrors,
                ["rewardPoints"]:
                  "The reward points exceeds the amount payable and cannot be applied",
              });
              setRewardsApplied((prevState) => ({
                ...prevState,
                // status: true,
                rewardPoints: "",
              }));
              setRewardMessage("");
            } else {
              setRewardAmount(initialfields.rewardPoints);
              setRewardsApplied({
                status: true,
                amount: res.data?.data[0].reward_balance,
                rewardPoints: res.data?.data[0].id,
              });
              setListErrors({
                ...listErrors,
                ["rewardPoints"]: "",
              });
            }
          } else {
            // Swal.fire({
            //   title: "Warning",
            //   text: "coupon code is not avaliable ",
            //   icon: "Warning",
            //   confirmButtonText: "Ok",
            // });

            setInitialfields((prevState) => ({
              ...prevState,
              status: false,
              amount: 0,
              rewardPoints: "",
            }));
            setRewardMessage(res.data.message);
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      setListErrors((prev) => ({
        ...prev,
        rewardPoints: "Please enter the reward points",
      }));
    }
  };

  const validateFocusCommentSection = (COMSECFO) => {
    if (COMSECFO.delivery_mode === "" && optional_paper_ref.current) {
      optional_paper_ref.current.focus();
    }
    if (COMSECFO.address === "" && deliveryRef.current) {
      deliveryRef.current.focus();
    }
    if (COMSECFO.address === "" && deliveryRef.current) {
      deliveryRef.current.focus();
    }
    if (COMSECFO.Verify === false && txtadVerifyHere.current) {
      txtadVerifyHere.current.focus();
    }
  };
  const validateFields = (data, addre) => {
    const errors = {};
    if (!data.Verify) {
      errors.Verify = "Please look and verify the Terms and Conditions";
    }
    if (!allEBook) {
      if (data.deliveryMode === null || data.deliveryMode === undefined) {
        errors.deliveryMode = "Please select a delivery mode";
      } else if (addre === "") {
        errors.addre = "Please select address";
      } else if (!data.Verify) {
        errors.Verify = "Please look and verify the Terms and Conditions";
      }
      validateFocusCommentSection(data);
      return errors;
    } else {
      return errors;
    }
  };

  const handleSubmit = (e) => {
    setMessage("");
    // window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top of the page
    const err_bnh = validateFields(initialfields, selectedId);
    setError(err_bnh);
    setMessage("");
    setListErrors((prev) => ({
      ...prev,
      rewardPoints: "",
    }));
    const userJSON = sessionStorage.getItem("userDetails");

    if (Object.keys(err_bnh).length === 0) {
      if (userJSON) {
        const user = JSON.parse(userJSON);
        if (user && user.user_id) {
          // setStepperButton(true);
          const userid = user.user_id;

          const CouresAmount = (
            totalFinalPrice +
            (initialfields.deliveryMode === 1
              ? courierCharges?.amount || 0
              : 0) -
            (totalOfferValue +
              (couponApplied.status &&
                message === "Coupon code applied successfully"
                ? parseInt(couponApplied.amount)
                : 0) +
              parseInt(rewardsnApplied.status === true ? rewardAmount : 0))
          ).toFixed(0);
          // const CouresName = cname;
          // const gstrate = 18;
          const soffer = totalOfferValue.toFixed(2);
          const discountAmount = (
            Number(totalOfferValue || 0) +
            Number(couponApplied.amount || 0) +
            Number(rewardAmount || 0)
          ).toFixed(2);

          // const coures_id = cId;
          // const batch_id = batchId;
          const receipt = "Order_" + userid;

          if (CouresAmount > 0) {
            AxiosInstance.post("api/book/create_order", {
              amount: parseInt((CouresAmount * 100).toFixed(2)),
              currency: "INR",
              receipt: receipt,
            })
              .then((res) => {
                if (res.data.status) {
                  const { data } = res;
                  let payment_status = "";
                  if (data.status === "failed") {
                    payment_status = 0;
                  } else if (data.status === "created") {
                    payment_status = 1;
                  } else if (data.status === "authenticated") {
                    payment_status = 2;
                  } else if (data.status === "authorized") {
                    payment_status = 3;
                  } else if (data.status === "captured") {
                    payment_status = 4;
                  } else if (data.status === "refunded") {
                    payment_status = 5;
                  }
                  setIsPaymentLoading(true);
                  const dat = {
                    id: "",
                    user_id: userid,
                    shipping_type: allEBook
                      ? 0
                      : parseInt(initialfields.deliveryMode),
                    shipping_address_pk: allEBook ? 2 : parseInt(selectedId),
                    payment_mode: 1,
                    actual_price: totalFinalPrice.toFixed(2),
                    special_offer: parseInt(soffer),
                    coupon_code: couponApplied.coupon_code || "",
                    coupon_amount:
                      couponApplied.status === true ? couponApplied.amount : 0,
                    reward_used:
                      parseInt(
                        rewardsnApplied.status === true ? rewardAmount : 0
                      ) > 0
                        ? 1
                        : 0,
                    reward_amount: parseInt(
                      rewardsnApplied.status === true ? rewardAmount : 0
                    ),
                    total_discount: parseInt(discountAmount),
                    courier_charge:
                      initialfields.deliveryMode === 1
                        ? courierCharges?.amount || 0
                        : 0,
                    courier_pk:
                      initialfields.deliveryMode === 1 ? courierCharges.id : 0,
                    total_amount: parseInt(CouresAmount),
                    transaction_status: payment_status,
                    transaction_order_id: data.id,
                    cart_id: bookListData.map((item) => item.id),
                    created_dt: moment
                      .unix(data.created_at)
                      .format("YYYY-MM-DD HH:mm:ss"),
                    created_by: userid,
                    items: bookListData.map((item) => {
                      return {
                        book_id: item.book_id,
                        quantity: item.count,
                        is_set: item.is_set,
                      };
                    }),
                  };
                  const handlePayment = (data, addre) => {
                    const errors = validateFields(data, addre);

                    if (Object.keys(errors).length > 0) {
                      setValidationErrors(errors); // Display errors in the UI
                      return;
                    }

                    setValidationErrors({}); //
                  };
                  AxiosInstance.post("api/book/orders", dat)
                    .then((res) => {
                      if (res.data.status === true) {
                        const purID = res.data.data.id;
                        setIsPaymentLoading(false);
                        const options = {
                          key: BookPaymentSKey,
                          amount: res.data.data.total_amount,
                          currency: "INR",
                          order_id: res.data.data.transaction_order_id,
                          handler: function (response) {
                            if (response) {
                              setIsPaymentLoading(true);
                              const dats = {
                                user_id: userid,
                                id: res?.data?.data?.id,
                                shipping_type: res.data.data.shipping_type,
                                shipping_address_pk:
                                  res.data.data.shipping_address_pk,
                                payment_mode: res.data.data.payment_mode,
                                actual_price: res.data.data.actual_price,
                                special_offer: res.data.data.special_offer,
                                coupon_code: res.data.data.coupon_code,
                                coupon_amount: res.data.data.coupon_amount,
                                reward_used: res.data.data.reward_used,
                                reward_amount: res.data.data.reward_amount,
                                total_discount: res.data.data.total_discount,
                                courier_charge: res.data.data.courier_charge,
                                total_amount: res.data.data.total_amount,
                                transaction_status:
                                  res.data.data.transaction_status,
                                transaction_order_id:
                                  res.data.data.transaction_order_id,
                                cart_id: res.data.data.cart_id,
                                created_dt: moment(res.data.created_at).format(
                                  "YYYY-MM-DD HH:mm:ss"
                                ),
                                created_by: userid,
                                items: res.data.data.items?.map((item) => {
                                  return {
                                    book_id: item.book_id,
                                    quantity: item.quantity,
                                    is_set: item.is_set,
                                  };
                                }),
                              };

                              AxiosInstance.post("api/book/purchase", dats)
                                .then((res) => {
                                  if (res.data.status === true) {
                                    setIsPaymentLoading(false);
                                    cartNotify(userid);
                                    navigate("/AddToCart/PaymentSuccess/0", {
                                      state: {
                                        purchase_id: purID,
                                        order_id:
                                          res.data.data.transaction_order_id,
                                      },
                                    });
                                    // setStepperButton(false);
                                  } else {
                                    setIsPaymentLoading(false);
                                    // setStepperButton(false);
                                  }
                                })
                                .catch((error) => {
                                  return error;
                                });
                            } else {
                              setIsPaymentLoading(false);
                              // setStepperButton(false);
                            }
                          },
                          modal: {
                            ondismiss: function () {
                              // Triggered when the Razorpay modal is closed by the user
                              navigate("/TransactionHistory/3"); // book tab for payment pending
                            },
                          },
                        };
                        const rzp1 = new window.Razorpay(options);
                        rzp1.open();

                        setIsPaymentLoading(false);
                      } else {
                        setIsPaymentLoading(false);
                        setValidationErrors({ apiError: res.data.message }); // Show API error as validation message
                      }
                    })
                    .catch((error) => {
                      Swal.fire({
                        title: "Warning",
                        text: error,
                        icon: "Warning",
                        confirmButtonText: "Ok",
                      });
                      // setStepperButton(false);
                      // setIsPaymentLoading(false);
                      return error;
                    });
                } else {
                  Swal.fire({
                    title: "Warning",
                    text: res.data.message,
                    icon: "Warning",
                    confirmButtonText: "Ok",
                  });
                  // setIsPaymentLoading(false);
                  // setStepperButton(false);
                }
              })
              .catch((error) => {
                Swal.fire({
                  title: "Warning",
                  text: error,
                  icon: "Warning",
                  confirmButtonText: "Ok",
                });
                // setIsPaymentLoading(false);
                // setStepperButton(false);
                return error;
              });
          } else {
            Swal.fire({
              title: "Warning",
              text: "Your price should be a minimum of 1 rupee. Kindly reach out to the administrator for assistance with this matter.",
              icon: "Warning",
              confirmButtonText: "Ok",
            });
            // setStepperButton(false);
            // setIsPaymentLoading(false);
          }
        }
      }
    } else {
      console.log("User Id cannot avaliable in session storage");
    }
  };
  const validateERRORDEFields = (NAME, PHONENUMBER, ADDRESS, PINCODE) => {
    const errors = {};
    if (NAME === "") {
      errors.name = "Please enter the name";
    }
    if (PHONENUMBER === "") {
      errors.phoneNumber = "Please enter the phone number ";
    }
    if (!/^[6-9][0-9]{9}$/.test(PHONENUMBER)) {
      errors.phoneNumber = "Please enter a valid 10-digit mobile number";
    }
    if (ADDRESS === "") {
      errors.address = "Please enter the address";
    }

    if (ADDRESS.trim() === "") {
      errors.address = "Please fill the address";
    }
    if (PINCODE === "") {
      errors.Pincode = "Please enter the pincode";
    }
    if (!/^[1-9][0-9]{5}$/.test(PINCODE)) {
      errors.Pincode = "Please enter a valid 6 digit pincode number";
    }
    return errors;
  };
  const handleAddressClose = () => {
    const errors = validateERRORDEFields(
      initialfields.name,
      initialfields.phoneNumber,
      initialfields.address,
      initialfields.Pincode
    );

    // If there are errors, set them and return early
    if (Object.keys(errors).length === 0) {
      const addAddress = {
        id: isEditopen ? initialfields.EditID : "",
        user_id: userid,
        name: initialfields.name,
        address: initialfields.address,
        phone_no: initialfields.phoneNumber,
        pincode: initialfields.Pincode,
        created_dt: moment().format("YYYY-MM-DD"),
        created_by: userid,
      };
      AxiosInstance.post("/api/book/cart/address/add", addAddress)
        .then((res) => {
          if (res.data.status) {
            toast.success(res.data.message);
            handleModelClose();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      setError(errors);
    }
  };

  const handleModelClose = () => {
    setOpen(false);
    setError({
      ...error,
      name: "",
      phoneNumber: "",
      address: "",
      Pincode: "",
    });
  };

  const handleModelOpen = () => {
    setOpen(true);
    setisEditopen(false);
    setInitialfields((prevList) => ({
      ...prevList,
      name: "",
      phoneNumber: "",
      address: "",
      Pincode: "",
    }));
  };

  const handleEditAddress = (datads) => {
    setOpen(true);
    setisEditopen(true);
    setInitialfields((prevList) => ({
      ...prevList,
      delivery_mode: 1,
      EditID: datads.id,
      name: datads.name,
      phoneNumber: datads.phone_no,
      address: datads.address,
      Pincode: datads.pincode,
    }));
  };

  useEffect(() => {
    const totals = bookListData.reduce(
      (acc, item) => {
        if (item.price !== null && item.offer_percentage !== null) {
          const offerValue =
            (item.price * item.offer_percentage * item.count) / 100;

          return {
            totalFinalPrice: acc.totalFinalPrice + item.finalPriceChanged,
            totalOfferValue: acc.totalOfferValue + offerValue,
          };
        }
        return acc;
      },
      { totalFinalPrice: 0, totalOfferValue: 0 }
    );
    setTotalFinalPrice(totals.totalFinalPrice);
    setTotalOfferValue(totals.totalOfferValue);
  }, [bookListData]);

  const CourierCharges = bookListData
    .filter((item) => item.is_ebook !== 1)
    .reduce((acc, item) => acc + item.weight * (item.count || 1), 0)
    .toFixed(3);

  const fetchCourierCharge = async (weight) => {
    try {
      const response = await AxiosInstance.post("api/book/courier_charge", {
        kg: Number(weight), // Ensure weight is a number
      });

      if (response.data.status) {
        setCourierCharge(response.data.amount[0]); // Store the charge dynamically
        setErrorMessage(""); // Clear error message on success
      } else {
        setErrorMessage(response.data.message); // Show validation message
        setCourierCharge([]); // Prevent saving
      }
    } catch (error) {
      setErrorMessage("Error fetching courier charge. Please try again.");
      console.error("Error fetching courier charge:", error);
      setCourierCharge([]);
    }
  };

  const { is_ebook } = bookListData || {};
  // Call API when CourierCharges changes
  useEffect(() => {
    if (is_ebook !== 1 && CourierCharges > 0) {
      fetchCourierCharge(CourierCharges);
    } else {
      setCourierCharge([]); // Set courier charge to zero if it's an eBook
    }
  }, [CourierCharges, is_ebook]);

  // const courierCharges = 50;
  const [selectedId, setSelectedId] = useState(""); // State to store selected id
  const addWishList = (idsBook, is_fav) => {
    AxiosInstance.post("api/book/wishlist/add", {
      user_id: userid,
      book_id: idsBook,
      is_favorite: is_fav == 1 ? 0 : 1,
      created_dt: moment().format("YYYY-MM-DD"),
      created_by: userid,
    })
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          setFlagReload(!flagReload);
          WishNotify(userid);
        } else {
          toast.error(res.data.message);
          sessionStorage.clear();
          navigate("/login");
        }
      })
      .catch((error) => {
        return error;
      });
  };

  // add to cart function
  const handleCartPage = (idss) => {
    AxiosInstance.post("/api/book/cart/add", {
      id: "",
      user_id: userid,
      book_id: idss,
      created_dt: moment().format("YYYY-MM-DD"),
      created_by: userid,
    })
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          setFlagReload(true);
          cartNotify(userid);
        } else {
          toast.error(res.data.message);
          setFlagReload(true);
        }
      })
      .catch((error) => {
        return error;
      });
  };
  const handleCheckboxChange = (event) => {
    const { value } = event.target;
    setSelectedId(value); // Update the state with the selected value
    setError({
      ...error,
      addre: "",
    });
  };
  let BooksPerPageforWidgets = 4;
  const [booksetIndex, setBooksetIndex] = useState(0);
  const totalPreOrderD =
    preorderListData.length > 0 ? preorderListData?.slice(-12) : [];
  const preorderdataD =
    totalPreOrderD.length > 0
      ? totalPreOrderD.slice(
        booksetIndex * BooksPerPageforWidgets,
        (booksetIndex + 1) * BooksPerPageforWidgets
      )
      : [];

  // prev button pagination
  const handlePrev_bookset = (val) => {
    if (val >= 0) {
      setBooksetIndex(val);
      window.scrollTo({ top: "1350", behavior: "smooth" }); // Scroll to top
    }
  };
  // next button pagination
  const handleNext_bookset = (val) => {
    if (val < 5 && preorderListData[booksetIndex]) {
      setBooksetIndex(val);
      window.scrollTo({ top: "1350", behavior: "smooth" }); // Scroll to top
    }
  };
  const firstHalf = updateListData.slice();
  const secondHalf = updateListData.slice();
  const handleViewAbooksnav = (book_id) => {
    navigate(`/ViewBook/${book_id}`);
  };

  const handleQuantityChange = (id, val) => {
    if (val === "" || (/^\d{1,4}$/.test(val) && parseInt(val, 10) >= 1)) {
      setBookListData((prev) =>
        prev.map((b) =>
          b.id === id
            ? {
              ...b,
              pendingQuantity: val === "" ? "" : parseInt(val, 10),
              isApplied: false,
            }
            : b
        )
      );
    }
  };

  // Button disabled logic
  const isApplyDisabled = (item) => {
    // disable only if input is empty or already applied
    return item.pendingQuantity === "" || item.isApplied;
  };

  return (
    <div
      className={`${cartInfo.CourseInfoSec}  container-fluid global_container BathHeader`}
    >
      {/* -------------Swastic-------------------- */}
      <div className="row mb-2">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader"> Cart </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                //   to={id ? "javascript:void(0)" : "/CourseManagement/1"}
                to={"/studyMaterials/Books/ViewAllBook"}
                //   onClick={id ? navigateToPreviousScreen : () => {}}
                onClick={() => navigateToPreviousScreen()}
                className="secondaryButton "
                variant="secondary"
              >
                Back to View All Books
              </Link>
            </li>

            <li class="ListBtnItems">
              <Link
                onClick={
                  bookListData.length === 0 ||
                    (initialfields.deliveryMode == 1 &&
                      courierCharges === null) ||
                    (initialfields.deliveryMode == 1 &&
                      errorMessage &&
                      Object.keys(errorMessage).length > 0) ||
                    !allApplied
                    ? undefined
                    : handleSubmit
                }
                className={`primaryButton ${bookListData.length === 0 ||
                    (initialfields.deliveryMode == 1 &&
                      courierCharges === null) ||
                    (initialfields.deliveryMode == 1 &&
                      errorMessage &&
                      Object.keys(errorMessage).length > 0) ||
                    !allApplied
                    ? "disabled_btn"
                    : ""
                  }`}
              >
                Proceed To Payment Gateway
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {preorderListData.length > 0 && (
        <div className="row mx-0">
          <div className="col-md-12 col-lg-12 col-12 px-0">
            <PreOrderNote preOrderdata={preorderListData} />
          </div>
        </div>
      )}

      <div className="row ">
        {/* Left Section - Book Details */}
        <div className="col-lg-8 mt-3">
          <fieldset>
            <legend className="w-auto"> Book Details </legend>

            {bookListData.length > 0 ? (
              bookListData.map((item) => {
                return (
                  <div className="card p-3 mb-3">
                    <div className="row">
                      {/* col - 1 */}
                      <div
                        className={`${cartInfo.margin_top} col-lg-3 d-flex justify-content-center justify-content-lg-start`}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleViewAbooksnav(item.book_id)}
                      >
                        {/* {item.is_ebook == 1 ? (
                          <img
                            src={PdfImage}
                            className={`${cartInfo.course_img} mb-2`}
                            alt=""
                          />
                        ) : ( */}
                        <img
                          src={
                            item.images[0]
                              ? `${ImageUrlPrefix}/${item.images[0]?.book_image_path}`
                              : PdfImage
                          }
                          className={`${cartInfo.course_img} mb-2`}
                          alt=""
                        />
                        {/* )} */}
                      </div>
                      {/* col - 2*/}
                      <div className="col-lg-5">
                        <div className="d-flex flex-column">
                          <p
                            className={`${BookInfo.ellipsis_book} confirm_value my-1 m-0 p-0`}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleViewAbooksnav(item.book_id)}
                          >
                            {item.book_title}
                          </p>
                          <p
                            className={`${BookInfo.BookSubTitle} ${BookInfo.ellipsis_book} mb-1 m-0 p-0`}
                          >
                            {item.author}
                          </p>
                        </div>
                        {/* 2 */}
                        <div className={`${cartInfo.BookborderRed}`}>
                          <p className={` my-1`}>
                            <span className={BookInfo.item_price}>
                              <CurrencyRupee className={BookInfo.rupees_icon} />
                              {item.finalPrice}
                            </span>
                            {item.offer_percentage > 0 && (
                              <>
                                <span className={BookInfo.item_price_disAmount}>
                                  {item.price}
                                </span>
                                <span className={BookInfo.item_price_offer}>
                                  {" "}
                                  {item.offer_percentage}% off
                                </span>
                              </>
                            )}
                            {item.is_ebook === 1 ? (
                              <span
                                className={`${cartInfo.stock_item_right_label} ms-3 mb-0`}
                              >
                                E - Book
                              </span>
                            ) : null}
                            {item.stock_count === 0 &&
                              item.is_set == 0 &&
                              item.is_ebook == 0 ? (
                              <span
                                className={`${cartInfo.stock_item_right_label} ms-3 mb-0`}
                              >
                                Out of Stock
                              </span>
                            ) : item.stock_count > 0 &&
                              item.stock_count < 10 &&
                              item.is_set == 0 &&
                              item.is_ebook == 0 ? (
                              <span
                                className={`${cartInfo.stock_item_right_label} ms-3 mb-0`}
                              >
                                {`Only ${item.stock_count} ${item.stock_count > 1 ? `books` : `book`
                                  } left`}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                        </div>
                        {/* 3 */}
                        {item.is_ebook == 0 && (
                          <div className="row">
                            {item.dimension !== null && (
                              <div className="my-1 col-lg-6 col-md-6 col-12">
                                <div className="">
                                  <p className="confirm_label m-0 p-0">
                                    Dimension
                                  </p>
                                  <p className="confirm_value my-1 m-0 p-0">
                                    {`${item.dimension} CM`}
                                  </p>
                                </div>
                              </div>
                            )}
                            {item.weight !== null && (
                              <div className="my-1 col-lg-6 col-md-6 col-12">
                                <div className="">
                                  <p className="confirm_label m-0 p-0">
                                    Weight
                                  </p>
                                  <p className="confirm_value my-1 m-0 p-0">
                                    {`${item.weight} KG`}
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      {/* col - 3 */}
                      <div
                        className={`${cartInfo.margin_top} col-lg-4 ListBtn`}
                      >
                        {/* <div className="forms ">
                          <div className=" text-center ">
                            <>
                              <span
                                className={`material-icons Increasecricle ${item.is_ebook == 1 || item.count == 1
                                  ? "disabled_btn"
                                  : ""
                                  }`}
                                style={{
                                  
                                  opacity:
                                    initialfields.NModelExam <= 0 ? 0.3 : 1,
                                  cursor:
                                    initialfields.NModelExam <= 0
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                                onClick={
                                  item.is_ebook == 1 || item.count <= 1
                                    ? () => { }
                                    : () => handleDecreaseModel(item.id)
                                }
                              >
                                remove_circle
                              </span>

                              <input
                                style={{
                                  width: "100px",
                                  marginLeft: "6px",
                                  textAlign: "center",
                                }}
                                type="text"
                                name="quantityCount"
                                class="Inputs"
                                id="NModelExam"
                                min={1}
                                readOnly={item.is_ebook == 1}
                                value={item.pendingQuantity ?? item.count}
                                onChange={(e) => handleQuantityChange(item.id, e.target.value)}
                              // onChange={(e) => {
                              //   let val = e.target.value;
                              //   if (val === "") {
                              //     setBookListData((prev) =>
                              //       prev.map((b) =>
                              //         b.id === item.id ? { ...b, pendingQuantity: "" } : b
                              //       )
                              //     );
                         
                              //     return;
                              //   }
                              //   let num = parseInt(val, 10);
                              //   if (num < 1) num = 1;
                              //   setBookListData((prev) =>
                              //     prev.map((b) =>
                              //       b.id === item.id
                              //         ? { ...b, pendingQuantity: num }
                              //         : b
                              //     )
                              //   );
                              // }}
                              />

                              <span
                                className={`material-icons Increasecricle ${(item.is_set == 0 &&
                                  item.count >= item.stock_count) ||
                                  item.is_ebook == 1
                                  ? "disabled_btn"
                                  : ""
                                  }`}
                                onClick={
                                  (item.is_set == 0 &&
                                    item.count >= item.stock_count) ||
                                    item.is_ebook == 1
                                    ? () => { }
                                    : () => handleIncreaseModel(item.id)
                                }
                              >
                                add_circle
                              </span>
                            </>
                          </div>
                          {error.addMaxBook && (
                            <small className={cartInfo.errors}>
                              {error.addMaxBook}
                            </small>
                          )}
                        </div> */}
                        <div className="forms">
                          <div
                            className="d-flex justify-content-center align-items-center gap-2"
                            style={{ minHeight: "40px" }}
                          >
                            {/* Decrease button */}
                            <span
                              className={`material-icons Increasecricle ${item.is_ebook == 1 || item.count == 1
                                  ? "disabled_btn"
                                  : ""
                                }`}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                opacity:
                                  initialfields.NModelExam <= 0 ? 0.3 : 1,
                                cursor:
                                  initialfields.NModelExam <= 0
                                    ? "not-allowed"
                                    : "pointer",
                                fontSize: "28px",
                              }}
                              onClick={
                                item.is_ebook == 1 || item.count <= 1
                                  ? () => { }
                                  : () => handleDecreaseModel(item.id)
                              }
                            >
                              remove_circle
                            </span>

                            {/* Quantity Input */}
                            <input
                              style={{
                                width: "80px",
                                textAlign: "center",
                                height: "36px",
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                              }}
                              type="text"
                              name="quantityCount"
                              className="Inputs"
                              id="NModelExam"
                              min={1}
                              readOnly={item.is_ebook == 1}
                              value={item.pendingQuantity ?? item.count}
                              onChange={(e) =>
                                handleQuantityChange(item.id, e.target.value)
                              }
                            />

                            {/* Increase button */}
                            <span
                              className={`material-icons Increasecricle ${item.is_ebook == 1 ? "disabled_btn" : ""
                                }`}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "28px",
                                cursor:
                                  item.is_ebook == 1
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                              onClick={
                                item.is_ebook == 1
                                  ? () => { }
                                  : () => handleIncreaseModel(item.id)
                              }
                            >
                              add_circle
                            </span>
                          </div>

                          {error.addMaxBook && (
                            <small className={cartInfo.errors}>
                              {error.addMaxBook}
                            </small>
                          )}
                        </div>

                        <div className="mt-3 d-flex justify-content-center justify-content-lg-end">
                          <ul class="m-0">
                            {item.is_ebook != 1 && (
                              <li
                                class={`d-flex justify-content-center text-center m-0`}
                              >
                                {/* <Link
                                  onClick={() => {
                                    if (item.pendingQuantity !== "" && item.pendingQuantity !== undefined) {
                                      handleApplyQuantity(item.id);
                                      // Mark as applied
                                      setBookListData((prev) =>
                                        prev.map((b) =>
                                          b.id === item.id
                                            ? {
                                              ...b,
                                              isApplied: true,
                                            }
                                            : b
                                        )
                                      );
                                    }
                                  }}

                                  className={`primaryButton ${item.pendingQuantity === "" || item.pendingQuantity === undefined || item.isApplied
                                    ? "disabled_btn"
                                    : ""
                                    }`}
                                  variant="secondary"
                                >
                                  {item.isApplied ? "Applied" : "Apply"}
                                </Link> */}

                                <Link
                                  onClick={() => {
                                    if (
                                      (item.pendingQuantity === "" && item.count === undefined) ||
                                      item.isApplied
                                    ) {
                                      return;
                                    }
                                    const quantity =
                                      item.pendingQuantity !== undefined &&
                                        item.pendingQuantity !== ""
                                        ? item.pendingQuantity
                                        : item.count;

                                    if (
                                      quantity !== "" &&
                                      quantity !== undefined
                                    ) {
                                      handleApplyQuantity(item.id);

                                      setBookListData((prev) =>
                                        prev.map((b) =>
                                          b.id === item.id
                                            ? {
                                              ...b,
                                              isApplied: true,
                                            }
                                            : b
                                        )
                                      );
                                    }
                                  }}
                                  className={`primaryButton ${(item.pendingQuantity === "" &&
                                      item.count === undefined) ||
                                      item.isApplied
                                      ? "disabled_btn"
                                      : ""
                                    }`}
                                  variant="secondary"
                                >
                                  {item.isApplied ? "Checked" : "Check Availability"}
                                </Link>
                              </li>
                            )}

                            <li class="d-flex justify-content-center text-center mt-2 ">
                              <Link
                                //   to={id ? "javascript:void(0)" : "/CourseManagement/1"}
                                to={"javascript:void(0)"}
                                onClick={() => handleRemove(item.id)}
                                className="secondaryButton p-0"
                                variant="secondary"
                              >
                                Remove this book from cart
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="card p-3 mb-3">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <p className="confirm_label"> No books to display </p>
                  </div>
                </div>
              </div>
            )}
          </fieldset>
        </div>
        {bookListData.length > 0 && (
          <div className="col-lg-4 mt-3">
            <fieldset>
              <legend className="w-auto"> Payment Details </legend>
              <div className="h-100">
                {/* 1 */}
                <div className="row mt-3">
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6 ">
                    <h6 className="confirm_value"> Actual Price </h6>
                  </div>
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                    <h6 className="confirm_value">
                      <CurrencyRupee
                        className={`${cartInfo.payment_currency}`}
                      />
                      {totalFinalPrice.toFixed(0)}
                    </h6>
                  </div>
                </div>
                {/* 2 */}
                <div className="row mt-3">
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6 ">
                    <h6 className="confirm_label"> Special Offer </h6>
                  </div>
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                    <h6 className="confirm_value">
                      <CurrencyRupee
                        className={`${cartInfo.payment_currency}`}
                      />
                      {totalOfferValue.toFixed(0)}
                      {/* {itk.offer_spl} */}
                    </h6>
                  </div>
                </div>
                {/* 3  coupon*/}
                <div className="row mt-3 align-items-center">
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6  ">
                    <h6 className="confirm_label"> Coupon Code </h6>
                  </div>
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6 d-flex justify-content-start">
                    <div>
                      <input
                        type="text"
                        name="couponCode"
                        value={couponApplied.coupon_code}
                        onChange={handleChange}
                        className={`form-control ${cartInfo.couponBox}`}
                        placeholder="Coupon Code"
                      />
                    </div>
                  </div>
                  {listErrors.coupon_code && (
                    <p
                      style={{ textAlign: "end" }}
                      className="errors mx-0 my-1"
                    >
                      {listErrors.coupon_code}
                    </p>
                  )}

                  {couponApplied.status === false && (
                    <p
                      style={{ textAlign: "end" }}
                      className="errors mx-0 my-1"
                    >
                      {message}
                    </p>
                  )}
                  <div className="row">
                    <div className="col-lg-6"> </div>
                    <div className={`col-lg-6   mt-2 mx-sm-0 mx-3`}>
                      <ul class={` List-Button`}>
                        <li class={`${cartInfo.applyBtn} ListBtnItems`}>
                          <Link
                            onClick={handleApplyCoupon}
                            className="primaryButton"
                            variant="secondary"
                          >
                            Apply Coupon Code
                          </Link>
                        </li>
                      </ul>
                    </div>

                    <div className="col-lg-3"> </div>
                    <div className={`${cartInfo.applyValid} col-lg-9 mt-2`}>
                      {(error.couponCode || successMessage) && (
                        <p
                          className={`${successMessage
                              ? BookInfo.item_price_offer
                              : cartInfo.redColor
                            }`}
                        >
                          {error.couponCode || successMessage}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* 4 */}
                {couponApplied.status &&
                  message === "Coupon code applied successfully" && (
                    <div className="row">
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6 ">
                        {couponApplied.status === true && (
                          <h6 className="payment_fees_name mb-0">
                            Coupon Code Amount
                          </h6>
                        )}
                      </div>
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                        {couponApplied.status && (
                          <h6 className="payment_fees mb-0">
                            {/* <span className="text-danger  fw-bold">{couCode.CouponCode}</span> */}
                            <CurrencyRupee className="payment_currency" />
                            <span>
                              {couponApplied.status &&
                                message === "Coupon code applied successfully"
                                ? parseInt(couponApplied.amount)
                                : 0}
                            </span>
                            {message && (
                              <span
                                className={`text-success ms-2 ${couponApplied.status &&
                                    message === "Coupon code applied successfully"
                                    ? "text-success"
                                    : "errors"
                                  }`}
                              >
                                {message}
                              </span>
                            )}
                          </h6>
                        )}
                      </div>
                    </div>
                  )}

                {/* 5  Reward Point*/}
                <div className="row mt-3 align-items-center">
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6 ">
                    <h6 className="confirm_label">
                      {" "}
                      Reward Points (In Rupees){" "}
                    </h6>
                    {/* <h6 className="confirm_label"> (In Rupees)</h6> */}
                  </div>
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6 d-flex justify-content-start">
                    <div>
                      <input
                        type="text"
                        name="rewardPoints"
                        value={initialfields.rewardPoints}
                        onChange={handleChange}
                        className={`form-control ${cartInfo.couponBox}`}
                        placeholder="Reward Points"
                      />
                    </div>
                  </div>
                  {listErrors.rewardPoints && (
                    <p
                      style={{ textAlign: "end" }}
                      className="errors mx-0 my-1"
                    >
                      {listErrors.rewardPoints}
                    </p>
                  )}
                  {rewardsnApplied.status === false && (
                    <p
                      style={{ textAlign: "end" }}
                      className="errors mx-0 my-1"
                    >
                      {rewardMessage}
                    </p>
                  )}
                  <div className="row">
                    <div className="col-lg-6"> </div>
                    <div className={`col-lg-6   mt-2 mx-sm-0 mx-3`}>
                      <ul class={` List-Button`}>
                        <li class={`${cartInfo.applyBtn} ListBtnItems`}>
                          <Link
                            onClick={handleApplyReward}
                            className="primaryButton"
                            variant="secondary"
                          >
                            Apply Reward Points
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-3"> </div>
                    <div className={`${cartInfo.applyValid} col-lg-9 mt-2`}>
                      {(error.rewardPoints || successMessage) && (
                        <p
                          className={`${successMessage
                              ? BookInfo.item_price_offer
                              : cartInfo.redColor
                            }`}
                        >
                          {error.rewardPoints || successMessage}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                    {rewardsnApplied.status === true && (
                      <h6 className="payment_fees_name">
                        Reward Points Amount
                      </h6>
                    )}
                  </div>
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                    {rewardsnApplied.status === true && (
                      <h6 className="payment_fees mb-0">
                        <CurrencyRupee className="payment_currency" />
                        <span className=""> {rewardAmount} </span>
                        <span
                          className="text-success ms-2"
                          style={{ fontSize: "14px" }}
                        >
                          (Reward points applied successfully)
                        </span>
                      </h6>
                    )}
                  </div>
                </div>

                {/* 7  Total Discount*/}
                <div className="row mt-3">
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6 ">
                    <h6 className="confirm_value"> Total Discount </h6>
                  </div>
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                    <h6 className="confirm_value">
                      <CurrencyRupee
                        className={`${cartInfo.payment_currency}`}
                      />
                      {/* 1,800 */}

                      {(
                        parseInt(
                          rewardsnApplied.status === true ? rewardAmount : 0
                        ) +
                        Number(totalOfferValue || 0) +
                        parseInt(
                          couponApplied.status &&
                            message === "Coupon code applied successfully"
                            ? parseInt(couponApplied.amount)
                            : 0
                        )
                      ).toFixed(0)}

                      {/* {itk.act_c_fee} */}
                    </h6>
                  </div>
                </div>
                {initialfields.deliveryMode == 1 && (
                  <div className="row mt-3">
                    <div className="col-6 col-sm-5 col-lg-6 col-md-6 ">
                      <h6 className="confirm_value"> Amount Payable </h6>
                    </div>
                    <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                      <h6 className="confirm_value">
                        <CurrencyRupee
                          className={`${cartInfo.payment_currency}`}
                        />
                        {/* 1,800 */}

                        {totalFinalPrice -
                          (
                            parseInt(
                              rewardsnApplied.status === true ? rewardAmount : 0
                            ) +
                            Number(totalOfferValue || 0) +
                            parseInt(
                              couponApplied.status &&
                                message === "Coupon code applied successfully"
                                ? parseInt(couponApplied.amount)
                                : 0
                            )
                          ).toFixed(0)}

                        {/* {itk.act_c_fee} */}
                      </h6>
                    </div>
                  </div>
                )}

                {/* 8 courier */}
                {!allEBook && initialfields.deliveryMode == 1 && (
                  <div className="row mt-3">
                    <div className="col-6 col-sm-5 col-lg-6 col-md-6 d-flex justify-content-left ">
                      <h6 className="confirm_label">
                        Courier Charges ({CourierCharges}kg)
                      </h6>
                      <span
                        id={cartInfo.impo}
                        class="material-icons"
                        onClick={handleOpenModal}
                      >
                        error
                      </span>
                      {/* ---POPUP---- */}

                      {/* Modal Component */}
                      <Modal
                        show={showModal}
                        onHide={handleCloseModal}
                        centered
                        className="modal-lg"
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>
                            Courier Charges Information{" "}
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="container">
                            {updateListData
                              .filter((course) => course.isActive === 1)
                              .reduce((rows, course, index, all) => {
                                if (index % 2 === 0) {
                                  rows.push([course]);
                                } else {
                                  rows[rows.length - 1].push(course);
                                }
                                return rows;
                              }, [])
                              .map((pair, index) => (
                                <div className={`col-12 `} key={index}>
                                  <div className="row">
                                    <div className="col-12 col-sm-6 px-4 mb-2">
                                      <div
                                        className={`${index % 2 === 0
                                            ? `${cartInfo.bgOddColor}`
                                            : `${cartInfo.bgEvenColor}`
                                          } row`}
                                      >
                                        <div className="col-3 p-0 text-end">
                                          {pair[0]?.start_gram_range} gms
                                        </div>
                                        <div className="col-1 p-0 text-end">
                                          {" "}
                                          to{" "}
                                        </div>
                                        <div className="col-3 p-0 text-end">
                                          {pair[0]?.end_gram_range} gms
                                        </div>
                                        <div className="col-2 p-0 text-end">
                                          -{" "}
                                        </div>
                                        <div className="col-2 offset-md-1 px-2 text-end">
                                          ₹{pair[0]?.amount}
                                        </div>
                                      </div>
                                    </div>
                                    {pair[1] && (
                                      <div className="col-12 col-sm-6 px-4 mb-2">
                                        <div
                                          className={`${index % 2 !== 0
                                              ? `${cartInfo.bgOddColor}`
                                              : `${cartInfo.bgEvenColor}`
                                            } row`}
                                        >
                                          <div className="col-3 p-0 text-end">
                                            {pair[1]?.start_gram_range} gms
                                          </div>
                                          <div className="col-1 p-0 text-end">
                                            {" "}
                                            to{" "}
                                          </div>
                                          <div className="col-3 p-0 text-end">
                                            {pair[1]?.end_gram_range} gms
                                          </div>
                                          <div className="col-2 p-0 text-end">
                                            -{" "}
                                          </div>
                                          <div className="col-2 offset-md-1 px-2 text-end">
                                            ₹{pair[1]?.amount}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                          </div>
                        </Modal.Body>

                        <Modal.Footer>
                          <Link
                            variant="primary"
                            className="primaryButton"
                            onClick={handleCloseModal}
                          >
                            Close
                          </Link>
                        </Modal.Footer>
                      </Modal>
                    </div>
                    <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                      <h6 className="confirm_value">
                        <CurrencyRupee
                          className={`${cartInfo.payment_currency}`}
                        />

                        {courierCharges?.amount || 0}

                        {/* {itk.offer_spl} */}
                      </h6>
                    </div>
                    {errorMessage && (
                      <small className={cartInfo.errors}>
                        {" "}
                        {errorMessage}{" "}
                      </small>
                    )}
                  </div>
                )}

                {/* 9 Net Amount */}
                <div className="row mt-3">
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6 ">
                    <h6 className="confirm_value"> Net Amount To Pay </h6>
                  </div>
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                    <h6 className="confirm_value">
                      <CurrencyRupee
                        className={`${cartInfo.payment_currency}`}
                      />
                      {/* 1,000 */}

                      {/* {
               (
                 totalFinalPrice.toFixed(2) -
                 parseInt(couponApplied.amount) +
                 parseInt(rewardsnApplied?.data?.length > 0
                   ? rewardsnApplied.data[0]?.reward_balance ?? ""
                   : 0) + totalOfferValue +
                 courierCharges +
                 GSTPRICE *
                 (totalFinalPrice.toFixed(2) -
                   couponApplied.amount +
                   parseInt(rewardsnApplied?.data?.length > 0
                     ? rewardsnApplied.data[0]?.reward_balance ?? ""
                     : 0)) + totalOfferValue
               ).toFixed(2)
             } */}

                      {(
                        totalFinalPrice +
                        (initialfields.deliveryMode === 1
                          ? courierCharges?.amount || 0
                          : 0) -
                        (totalOfferValue +
                          (couponApplied.status &&
                            message === "Coupon code applied successfully"
                            ? parseInt(couponApplied.amount)
                            : 0) +
                          parseInt(
                            rewardsnApplied.status === true ? rewardAmount : 0
                          ))
                      ).toFixed(0)}

                      {/* {itk.act_c_fee} */}
                    </h6>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        )}
      </div>
      {!allEBook && (
        <div>
          <fieldset className="mt-3">
            <legend className="w-auto">
              {/* {" "}
    {initialfields.deliveryMode == 1
      ? "Delivery Address"
      : "Pickup Address"} */}
              Delivery Address
            </legend>
            <form className="row g-3">
              <div className="col-md-6">
                <label
                  htmlFor="examName"
                  className="form-label confirm_value cursorPnt"
                >
                  {initialfields.deliveryMode == 1
                    ? "Delivery Mode"
                    : "Pickup Mode"}
                </label>
                <div>
                  <input
                    ref={optional_paper_ref}
                    className={`shadow-none input-font-size ${cartInfo.checkbox_radio} cursorPnt`}
                    type="radio"
                    checked={initialfields.deliveryMode == 1 ? true : false}
                    id="yes"
                    name="deliveryMode"
                    value={1}
                    onChange={handleChange}
                  />
                  <label
                    htmlFor="yes"
                    className={`${cartInfo.margin_right} form-label confirm_value cursorPnt`}
                  >
                    Courier Delivery
                  </label>

                  <input
                    ref={optional_paper_ref}
                    className={`shadow-none input-font-size ${cartInfo.checkbox_radio} cursorPnt`}
                    type="radio"
                    id="no"
                    name="deliveryMode"
                    value={0}
                    checked={initialfields.deliveryMode == 0 ? true : false}
                    onChange={handleChange}
                  />
                  <label
                    htmlFor="no"
                    className="form-label confirm_value cursorPnt"
                  >
                    Collect at Branch
                  </label>
                </div>

                {error.deliveryMode && (
                  <small className={cartInfo.errors}>
                    {error.deliveryMode}
                  </small>
                )}
              </div>
              <div className="col-md-6 col-12 ListBtn ">
                {initialfields.deliveryMode == 1 && (
                  <ul class="List-Button mt-2">
                    <li class="ListBtnItems">
                      <Link
                        onClick={() => handleModelOpen()}
                        to="#exampleModalLabel"
                        className="primaryButton "
                      >
                        Add New Delivery Address
                      </Link>
                    </li>
                  </ul>
                )}
              </div>
            </form>
            {initialfields.deliveryMode == 1 && (
              <div className="borderWidth  mt-2">
                {delivery.length > 0 &&
                  delivery.map((io) => (
                    <div className="ulFilterListData d-flex">
                      <div className="filterListData col-md-6">
                        <input
                          ref={deliveryRef}
                          type="radio"
                          className="ListCheckbox"
                          name="onlineAddress"
                          id={`onlineAddress-${io.id}`}
                          value={io.id}
                          checked={String(selectedId) === String(io.id)}
                          onChange={handleCheckboxChange}
                        />
                        <div className={cartInfo.addressHead}>
                          <div>
                            <label
                              className=" confirm_value "
                              style={{ wordBreak: "break-word" }}
                              htmlFor={`onlineAddress-${io.id}`}
                            >
                              {io.name} - {io.phone_no}
                            </label>
                          </div>
                          <div>
                            <label
                              className=" confirm_value "
                              style={{ wordBreak: "break-word" }}
                              htmlFor={`onlineAddress-${io.id}`}
                            >
                              {io.address}
                            </label>
                          </div>
                          <div>
                            <label
                              className=" confirm_value "
                              htmlFor={`onlineAddress-${io.id}`}
                            >
                              {io.pincode}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        class={` ${cartInfo.editAddress} ListBtnItems col-md-6`}
                      >
                        <Link
                          to="javascript:void(0)"
                          onClick={() => handleEditAddress(io)}
                          className="primaryButton"
                          variant="primary"
                        >
                          {" "}
                          <span className="material-icons me-1 fs-5 align-middle text-white">
                            border_color
                          </span>{" "}
                          Edit Address
                        </Link>
                      </div>
                    </div>
                  ))}
                {error.addre && (
                  <small className={cartInfo.errors}> {error.addre} </small>
                )}
              </div>
            )}
            {initialfields.deliveryMode == 0 && (
              <div className="borderWidth  mt-2">
                <ul className="ulFilterListData">
                  {branchdelivery.length > 0 &&
                    branchdelivery.map((ui) => (
                      <li className="filterListData">
                        <input
                          type="radio"
                          className="ListCheckbox"
                          name="NotYetAssigned"
                          value={ui.id}
                          id={`NotYetAssigned-${ui.id}`}
                          checked={String(selectedId) === String(ui.id)}
                          onChange={handleCheckboxChange}
                        />
                        <div className={cartInfo.addressHead}>
                          <div>
                            <label
                              className=" confirm_value "
                              htmlFor={`NotYetAssigned-${ui.id}`}
                            >
                              {ui.name} - {ui.phoneNumber}
                            </label>
                          </div>
                          <div>
                            <label
                              className="confirm_value "
                              htmlFor={`NotYetAssigned-${ui.id}`}
                            >
                              {ui.address}
                            </label>
                          </div>
                          <div>
                            <label
                              className=" confirm_value "
                              htmlFor={`NotYetAssigned-${ui.id}`}
                            >
                              {ui.Pincode}
                            </label>
                          </div>
                        </div>
                      </li>
                    ))}
                </ul>
                {error.addre && (
                  <small className={cartInfo.errors}> {error.addre} </small>
                )}
              </div>
            )}
          </fieldset>
        </div>
      )}

      {preorderdataD.length > 0 && (
        <div className="row mt-3">
          <div className="col-lg-12 col-md-12 ">
            <fieldset>
              <legend className="w-auto">
                {" "}
                Pre - Order Books in this Set{" "}
              </legend>
              <div className={`row`}>
                {preorderdataD.length > 0 &&
                  preorderdataD.map((iop) => (
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-2">
                      <CardTemplate
                        items={iop}
                        toggleWish={addWishList}
                        handleSubmitCart={() => handleCartPage(iop.id)}
                      />
                    </div>
                  ))}
              </div>
              <div className="row">
                <PaginationTop10
                  totCount={Array.from({
                    length: Math.ceil(
                      totalPreOrderD.length / BooksPerPageforWidgets
                    ),
                  })}
                  currentPage={booksetIndex}
                  onPageChange={setBooksetIndex}
                  hPrev={handlePrev_bookset}
                  hNext={handleNext_bookset}
                />
              </div>
            </fieldset>
          </div>
        </div>
      )}

      {open && (
        <Modal
          key={`modal-0-${0}`}
          show={open}
          onHide={handleModelClose}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h5
                className={`${cartInfo.view_title} fw-bold mb-0`}
                id="exampleModalLabel"
              >
                {isEditopen ? "Edit Address" : "Add New Delivery Address"}
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <></>
            <div className="row global_container">
              <div className="col-12">
                <form className="row g-3">
                  {/* Evaluator Name Dropdown */}
                  <div className="col-md-6">
                    <label for="name" class="form-label confirm_value ">
                      Name
                    </label>
                    <input
                      // ref={course_ref}
                      class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                      type="text"
                      id="Name"
                      name="name"
                      placeholder="Enter the name"
                      value={initialfields.name}
                      onChange={handleChange}
                    />
                    {error.name && (
                      <small className="error_message"> {error.name} </small>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label for="phoneNumber" class="form-label confirm_value ">
                      Phone Number
                    </label>
                    <input
                      // ref={course_ref}
                      class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                      type="text"
                      id="phoneNumber"
                      name="phoneNumber"
                      placeholder="Enter the phone number"
                      value={initialfields.phoneNumber}
                      onChange={handleChange}
                    />
                    {error.phoneNumber && (
                      <small className="error_message">
                        {error.phoneNumber}
                      </small>
                    )}
                  </div>

                  <div className="col-md-12">
                    <label for="address" class="form-label confirm_value ">
                      Address
                    </label>
                    <textarea
                      // ref={subject_ref}
                      className={`${cartInfo.desc_input} w-100 rounded p-2 input-font-size`}
                      placeholder="Enter the address"
                      id="address"
                      onChange={(e) => handleChange(e)}
                      value={initialfields.address}
                      name="address"
                      maxLength={500}
                      style={{
                        height: "auto",
                        // minHeight: "calc(24px * 8)",
                      }}
                    >
                      {" "}
                    </textarea>
                    {error.address && (
                      <small className="error_message"> {error.address} </small>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label for="Pincode" class="form-label confirm_value ">
                      Pincode
                    </label>
                    <input
                      // ref={course_ref}
                      class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                      type="text"
                      id="pincode"
                      name="Pincode"
                      placeholder="Enter the pincode"
                      value={initialfields.Pincode}
                      onChange={handleChange}
                    />
                    {error.Pincode && (
                      <small className="error_message"> {error.Pincode} </small>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <ul className="List-Button">
              <li className="ListBtnItems">
                <Link onClick={handleModelClose} className="secondaryButton">
                  Back to Cart
                </Link>
              </li>
              <li className="ListBtnItems">
                <Link onClick={handleAddressClose} className="primaryButton">
                  {isEditopen ? "Update Now" : "Add Now"}
                </Link>
              </li>
            </ul>
          </Modal.Footer>
        </Modal>
      )}

      {/* quantity error msg */}
      <div className="d-flex justify-content-end mt-3">
        {validationErrors.apiError && (
          <div className="error-message TitleHeader">
            {validationErrors.apiError}
          </div>
        )}
      </div>
      <div className="col-md-12">
        <div className="form-check form-check-inline" id="Verifycheckbox">
          <input
            ref={txtadVerifyHere}
            className="form-check-input mt-0"
            type="checkbox"
            id="Verify"
            name="Verify"
            onChange={handleChange}
            checked={initialfields.Verify === true ? true : false}
            value="Yes"
          />
          <label className="LablePrivacyText" htmlFor="Verify">
            I hereby certify that the above information are true and correct to
            the best of my knowledge and belief.
            <a
              className="LablePrivacy align-baseline"
              // target="_blank"
              rel="noopener noreferrer"
              href={"/BooksTermsAndCondition"}
            >
              Terms and Conditions
            </a>
          </label>
        </div>
      </div>
      {error.Verify && (
        <small className={cartInfo.errors}> {error.Verify} </small>
      )}
      <div className="col-md-12 mt-3 mb-3 col-12 ListBtn">
        <ul class="List-Button">
          <li class="ListBtnItems">
            <Link
              //   to={id ? "javascript:void(0)" : "/CourseManagement/1"}
              to={"/studyMaterials/Books/ViewAllBook"}
              //   onClick={id ? navigateToPreviousScreen : () => {}}
              onClick={() => navigateToPreviousScreen()}
              className="secondaryButton "
              variant="secondary"
            >
              Back to View All Books
            </Link>
          </li>
          <li class="ListBtnItems">
            <Link
              onClick={
                bookListData.length === 0 ||
                  (initialfields.deliveryMode == 1 && courierCharges === null) ||
                  (initialfields.deliveryMode == 1 &&
                    errorMessage &&
                    Object.keys(errorMessage).length > 0) ||
                  !allApplied
                  ? undefined
                  : handleSubmit
              }
              className={`primaryButton ${bookListData.length === 0 ||
                  (initialfields.deliveryMode == 1 && courierCharges === null) ||
                  (initialfields.deliveryMode == 1 &&
                    errorMessage &&
                    Object.keys(errorMessage).length > 0) ||
                  !allApplied
                  ? "disabled_btn"
                  : ""
                }`}
            >
              Proceed To Payment Gateway
            </Link>
          </li>
        </ul>
      </div>

      {isPaymentLoading && (
        <Dialog open={isPaymentLoading}>
          <DialogContent>
            <div style={{ margin: "15px" }}>
              {/* <div className="spinner-border text-danger"></div>{" "} */}
              <p> We are processing your payment.Please wait...</p>
            </div>
          </DialogContent>
        </Dialog>
      )}
      {isstockLoading && (
        <Dialog open={isstockLoading}>
          <DialogContent>
            <div style={{ margin: "15px" }}>
              <p>Loading...</p>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
